import { CCard, CCardBody } from '@coreui/react'
import moment from 'moment-jalaali'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'
import { getInvoiceDetailAction } from '../../../../service/actions/packageAction'
import { createNowPaymentURL, enToPersianChar } from '../../../../components/helper'
import PayPage from './payPage'

// import { whmcs } from '../../../../service/apiCall'

const Pay = ({
  pageType,
  invoicId,
  setInvoiceId,
  purchasedPackage
}) => {
  const location = useLocation();
  const [invoice, setInvoice] = useState()
  const [user, setUser] = useState()
  const [invoiceDate, setInvoiceDate] = useState()
  const params = useParams()
  const dispatch = useDispatch()
  const getInvoicePending = useSelector(state => state.packageReducer.getInvoiceDetailPending)
  const invoiceDetail = useSelector(state => state.packageReducer.invoiceDetail)
  const [selectedPM, setSelectedPM] = useState("mellat")
  const { t, i18n } = useTranslation()
  const [showModal, setShowModal] = useState(false)
  const [duration, setDuration] = useState()


  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("sipOnlineUser")))
    if (pageType) {
      dispatch(getInvoiceDetailAction(invoicId))
      setShowModal(true)
    }
    else {
      dispatch(getInvoiceDetailAction(params.id))
      setShowModal(false)
    }
    document.title = t("TITLE.INVOICE_ITEMS")


  }, [])

  useEffect(() => {
    if (invoiceDetail?.extraInfo) {

      setInvoiceDate(moment(new Date(invoiceDetail?.extraInfo?.date)))
      setSelectedPM(invoiceDetail.extraInfo.paymentmethod)
      setDuration(invoiceDetail?.duration)
      if (pageType) {
        setShowModal(true)
      }

    }
  }, [invoiceDetail])

  return (

    <PayPage
      pageType={pageType}
      duration={duration}
      selected={selectedPM}
      price={invoiceDetail?.extraInfo.total}
      currency={invoiceDetail?.currency}
      setSelect={setSelectedPM}
      user={user}
      status={invoiceDetail?.extraInfo?.status}
      invoiceId={params.id}
      setShowModal={setShowModal}
      showModal={showModal}
      setInvoiceId={setInvoiceId}
      purchasedPackage={purchasedPackage}
      invoiceDetail={invoiceDetail}
    />



  )
}

export default Pay